// @ts-nocheck
/**
 * Ludipek "sitio en construcción" notice.
 *
 * Opens the <dialog> rendered by snippets/ludipek-construction-modal.liquid on the first page
 * view and remembers the dismissal in localStorage so it never nags on the next navigation.
 * The storage key carries the notice version (the `ludipek_construction_notice_version` theme
 * setting), so bumping that setting after editing the copy re-shows the notice to everyone who
 * already closed the previous one; keys for older versions are pruned once the new one is stored.
 *
 * In the theme editor (`data-notice-preview`) the notice opens non-modally and never persists the
 * dismissal, so the merchant can keep previewing edits without the top layer making the rest of
 * the preview inert on every reload.
 */
(function () {
  const KEY_PREFIX = 'ludipek:construction_dismissed:';
  // Horizon's own scroll lock (assets/dialog.js sets it, base.css freezes html on it). Reused here
  // instead of a private class so the page behind this dialog behaves like it does behind the
  // search and quick-add modals.
  const SCROLL_LOCK_ATTRIBUTE = 'scroll-lock';

  const dialog = document.querySelector('[data-construction-notice]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const isPreview = dialog.hasAttribute('data-notice-preview');
  const storageKey = `${KEY_PREFIX}${dialog.dataset.noticeVersion || '1'}`;

  function wasDismissed() {
    // Private-mode Safari throws on localStorage access — treat that as "not dismissed" so the
    // notice still shows rather than silently disappearing for those visitors.
    try {
      return localStorage.getItem(storageKey) !== null;
    } catch (error) {
      console.debug('[construction-notice] could not read dismissal', { error: String(error) });
      return false;
    }
  }

  function rememberDismissal() {
    // Store first, prune second: if the write throws on a full quota, the visitor keeps whatever
    // dismissal they already had instead of losing every key and being re-prompted.
    try {
      localStorage.setItem(storageKey, '1');
    } catch (error) {
      console.debug('[construction-notice] could not persist dismissal', { error: String(error) });
      return;
    }
    // Index loop rather than Object.keys(localStorage), matching b2b-cache.js.
    const staleKeys = [];
    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);
      if (key !== null && key.startsWith(KEY_PREFIX) && key !== storageKey) staleKeys.push(key);
    }
    for (const key of staleKeys) localStorage.removeItem(key);
  }

  if (!isPreview && wasDismissed()) return;

  dialog.addEventListener('close', function () {
    // Covers every close path at once: the CTA, the × button, Escape and the backdrop click.
    document.documentElement.removeAttribute(SCROLL_LOCK_ATTRIBUTE);
    if (!isPreview) rememberDismissal();
  });

  for (const button of dialog.querySelectorAll('[data-construction-dismiss]')) {
    button.addEventListener('click', function () {
      dialog.close();
    });
  }

  // Backdrop click. A modal <dialog> reports clicks on its own backdrop as targeting the dialog,
  // but so does a click whose mouseup happens to land there after a text-selection drag that
  // STARTED inside the panel — closing on that would burn the visitor's one dismissal on an
  // accident. Require both ends of the click to be the backdrop.
  let pressStartedOnBackdrop = false;
  dialog.addEventListener('mousedown', function (event) {
    pressStartedOnBackdrop = event.target === dialog;
  });
  dialog.addEventListener('click', function (event) {
    if (pressStartedOnBackdrop && event.target === dialog) dialog.close();
    pressStartedOnBackdrop = false;
  });

  if (isPreview) {
    dialog.show();
    return;
  }
  dialog.showModal();
  document.documentElement.setAttribute(SCROLL_LOCK_ATTRIBUTE, '');
})();
